import React from 'react';
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram, FaEnvelope, FaPhone, FaMapMarkerAlt, FaBrain, FaFileAlt, FaLaptopCode, FaTrophy, FaRobot, FaMobile } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="container">
          <div className="footer-grid">
            {/* Company Info */}
            <div className="footer-section">
              <div className="footer-logo">
                <img src="/Logo.png" alt="CodeViaje Logo" className="footer-logo-img" />
                <div className="footer-logo-text">
                  <h3>CODEVIAJE</h3>
                  <p>Innovative IT Solutions</p>
                </div>
              </div>
              <p className="footer-description">
                We specialize in providing cutting-edge projects across the latest IT domains, 
                catering to both mini and major project needs with complete customization and support.
              </p>
              <div className="social-links">
                <a href="https://www.facebook.com/codeviaje" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Facebook">
                  <FaFacebook />
                </a>
                <a href="https://www.twitter.com/codeviaje" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Twitter">
                  <FaTwitter />
                </a>
                <a href="https://www.linkedin.com/company/codeviaje" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="LinkedIn">
                  <FaLinkedin />
                </a>
                <a href="https://www.instagram.com/codeviaje" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
                  <FaInstagram />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-section">
              <h4 className="footer-title">
                <span className="title-icon">🔗</span>
                Quick Links
              </h4>
              <ul className="footer-links">
                <li><Link to="/" className="footer-link">🏠 Home</Link></li>
                <li><Link to="/Projects" className="footer-link">📁 Projects</Link></li>
                <li><Link to="/Contact" className="footer-link">📞 Contact</Link></li>
                <li><Link to="/About" className="footer-link">ℹ️ About Us</Link></li>
                <li><Link to="/Services" className="footer-link">⚙️ Services</Link></li>
              </ul>
            </div>

            {/* Services */}
            <div className="footer-section">
              <h4 className="footer-title">
                <span className="title-icon">🚀</span>
                Our Services
              </h4>
                      <ul className="footer-links">
                        <li><Link to="/Projects?filter=Machine Learning" className="footer-link service-link">
                          <FaRobot className="service-icon" />
                          <span>Machine Learning</span>
                        </Link></li>
                        <li><Link to="/Projects?filter=Deep Learning" className="footer-link service-link">
                          <FaBrain className="service-icon" />
                          <span>Deep Learning</span>
                        </Link></li>
                        <li><Link to="/Projects?filter=Web Application" className="footer-link service-link">
                          <FaLaptopCode className="service-icon" />
                          <span>Web Applications</span>
                        </Link></li>
                        <li><Link to="/Projects?filter=Mobile" className="footer-link service-link">
                          <FaMobile className="service-icon" />
                          <span>Mobile Apps</span>
                        </Link></li>
                        <li><Link to="/Projects?filter=Research" className="footer-link service-link">
                          <FaFileAlt className="service-icon" />
                          <span>Research Papers</span>
                        </Link></li>
                        <li><Link to="/Projects?filter=Final Year" className="footer-link service-link">
                          <FaTrophy className="service-icon" />
                          <span>Final Year Projects</span>
                        </Link></li>
                      </ul>
            </div>

            {/* Contact Info */}
            <div className="footer-section">
              <h4 className="footer-title">
                <span className="title-icon">📞</span>
                Contact Info
              </h4>
              <div className="contact-info">
                <div className="contact-item">
                  <div className="contact-icon">
                    <FaPhone />
                  </div>
                  <div className="contact-details">
                    <span className="contact-label">Call us anytime</span>
                    <span className="contact-value">+91-7019194530</span>
                  </div>
                </div>
                <div className="contact-item">
                  <div className="contact-icon">
                    <FaEnvelope />
                  </div>
                  <div className="contact-details">
                    <span className="contact-label">Email us</span>
                    <span className="contact-value">support@codeviaje.in</span>
                  </div>
                </div>
                <div className="contact-item">
                  <div className="contact-icon">
                    <FaMapMarkerAlt />
                  </div>
                  <div className="contact-details">
                    <span className="contact-label">Location</span>
                    <span className="contact-value">Available Worldwide</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>&copy; {currentYear} CodeViaje. All rights reserved.</p>
              <p className="tagline">Empowering Innovation Through Technology</p>
            </div>
            <div className="footer-bottom-links">
              <Link to="/Privacy" className="legal-link">Privacy Policy</Link>
              <Link to="/Terms" className="legal-link">Terms of Service</Link>
              <Link to="/Cookies" className="legal-link">Cookie Policy</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
